import { render, staticRenderFns } from "./ServiceUnits.vue?vue&type=template&id=51db38f8"
import script from "./ServiceUnits.vue?vue&type=script&lang=js"
export * from "./ServiceUnits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports